import { render, staticRenderFns } from "./GeraCreditosPendentes.vue?vue&type=template&id=03da55e6"
import script from "./GeraCreditosPendentes.vue?vue&type=script&lang=js"
export * from "./GeraCreditosPendentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports